module.exports = __webpack_public_path__ + "img/law-school.62491acd.svg";